import React from "react";
import DashboardScope2 from "../Pages/Scope2/Dashboard";
import ConsumptionByEquipment from "../Pages/Scope2/Heat/ConsumptionByEquipment/ConsumptionEquipment";
import ConsumptionByFacility from "../Pages/Scope2/Heat/ConsumptionByFacility";
import ElectrictyConsumptionFacility from "../Pages/Scope2/ElectricityConsumption";
import ElectrictyConsumptionEquipment from "../Pages/Scope2/ElectricityConsumption/ConsumptionByEquipment";
import SteamConsumptionFacility from "../Pages/Scope2/Steam/ConsumptionByFacility";
import SteamConsumptionByEquipment from "../Pages/Scope2/Steam/ConsumptionByEquipment";

export const Scope2Routes = [
  { path: "/scope2/dashboard", element: <DashboardScope2 /> },
  {
    path: "/scope2/heat/consumption-by-equipment",
    element: <ConsumptionByEquipment />,
  },
  {
    path: "/scope2/heat/consumption-by-facility",
    element: <ConsumptionByFacility />,
  },
  {
    path: "scope2/steam/consumption-by-facility",
    element: <SteamConsumptionFacility />,
  },
  {
    path: "scope2/steam/consumption-by-equipment",
    element: <SteamConsumptionByEquipment />,
  },
  {
    path: "scope2/ElectrictyConsumptionFacility",
    element: <ElectrictyConsumptionFacility />,
  },
  {
    path: "scope2/ElectrictyConsumptionEquipment",
    element: <ElectrictyConsumptionEquipment />,
  },
];
